import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { Divider, Card, Menu, Dropdown, List, Typography,
    Space, Modal, Tag, Popover, Row } from 'antd';
import PercentageAllocator from "../../components/PercentageAllocator";
import useBuilderDrafts from "./useBuilderDrafts";
import Placeholder from "../../components/Placeholder";
import EventCard from "../../components/EventCard/EventCard";
import Avatars from "../../components/Graphics/Avatars";
import {PortfolioTypes} from "../../utils/strings";
import {useEnsureTickersLoaded} from "../../hooks/useEnsureTickersLoaded";
import {stringMixin} from "../../utils/strings";




const BuilderCard = ({draftObject, handleOpenDraft, handleDeleteBuilder, handleCopyDraft  }) => {
    const {items, stateId, name} = draftObject;
    const tickerIds = items.filter(item=>!PortfolioTypes.hasOwnProperty(item.type) && item.id !== 'custodial_cash').map(item=>item.id)
    const portfolioIds = items.map(item=>PortfolioTypes[item.type]);
    const {tickers} = useEnsureTickersLoaded(tickerIds);
    console.log(tickers)
    const tickerLogos = tickers?.length > 0 && tickers.map(ticker=>ticker.logo);
    console.log(draftObject)
    console.log(tickerLogos);
     const totalWeight = items.map(item=>item.wgt).reduce((a,b)=>a+b, 0);

    return (
        <EventCard title={name}
                   text={`Total Weight ${stringMixin.pct(totalWeight, {mult: 1})}. ${portfolioIds.length} Portfolios and ${tickerIds.length} Tickers.`}
                   content={<Avatars urls={tickerLogos} alt={items.map(item=>item.name)} size={32} />}
                   bottomLeft={<div>{items.length} Items in Portfolio</div>}
                   bottomRight={<Button variant={'outlined'} onClick={()=>handleOpenDraft(stateId)}>Open</Button>}
                   color="blue"
        />
    )
}

const BuilderDrafts = ({ data, selectedRowKeys, handleSelectRow, handleDeleteBuilder, handleOpenDraft, handleCopyDraft }) => {
    const sortedItemsByWgt = (items) => [...items].sort((a, b) => b.wgt - a.wgt);
    const renderHoldingsPopoverContent = (items) => (
        <List
            dataSource={sortedItemsByWgt(items)}
            style={{width: 400}}
            title={<Typography.Title level={5}>{data.length} Holdings</Typography.Title>}
            size="large"
            renderItem={(item, index) => (
                <List.Item key={item.id}
                           actions={[
                               <Typography.Text strong>{item.wgt.toFixed(3)}%</Typography.Text>
                           ]}

                >
                    <List.Item.Meta title={<Typography.Text strong ellipsis={{rows: 1}}>{index}) {item.name.toUpperCase()}</Typography.Text>}>

                    </List.Item.Meta>
                </List.Item>
            )}
        />
    );
    return (
        <List
            dataSource={sortedItemsByWgt(data)}
            renderItem={(item) => (
                <BuilderCard draftObject={item}
                             handleDeleteBuilder={handleDeleteBuilder}
                             handleOpenDraft={handleOpenDraft}
                             handleCopyDraft={handleCopyDraft}
                />
            )}
        />
    );
}

const BuilderStatesManager = () => {
    const {
        data,
        selectedRowKeys,
        modalOpen,
        handleOpenDraft,
        handleDeleteBuilder,
        handleDeleteSelected,
        handleMergeSelected,
        onFinishMerge,
        handleSelectRow,
        setModalOpen,
        handleCopyDraft
    } = useBuilderDrafts();

    const menu = (
        <Menu>
            <Menu.Item key="1" onClick={handleDeleteSelected} disabled={selectedRowKeys.length === 0}>
                Remove Selected
            </Menu.Item>
            <Menu.Item key="2" onClick={handleMergeSelected} disabled={selectedRowKeys.length < 2}>
                Merge Selected
            </Menu.Item>
        </Menu>
    );

    return (
        data.length > 0 ?
            <div>
                {selectedRowKeys.length > 0 && (
                    <Row justify={'space-between'} className={'px-4'}>
                        <Dropdown overlay={menu} placement="bottomCenter">
                            <Button variant={selectedRowKeys.length === 0 ? 'outlined' : 'contained'} color={selectedRowKeys.length === 0 ? 'inherit' : 'info'} disabled={selectedRowKeys.length === 0} style={{ marginBottom: 16 }}>
                                Selected Builds
                            </Button>
                        </Dropdown>
                    </Row>
                )}
                <BuilderDrafts
                    data={data}
                    selectedRowKeys={selectedRowKeys}
                    handleOpenDraft={handleOpenDraft}
                    handleDeleteBuilder={handleDeleteBuilder}
                    handleSelectRow={handleSelectRow}
                    handleCopyDraft={handleCopyDraft}
                />
                <Modal open={modalOpen} onOk={() => setModalOpen(false)} onCancel={() => setModalOpen(false)}>
                    <PercentageAllocator
                        items={selectedRowKeys.map(key => ({ key, name: data.find(item => item.key === key).name }))}
                        onFinish={onFinishMerge}
                    />
                </Modal>
        </div> :
            <Card bordered={false}>
                <Divider/>
                <Placeholder text={'No Builders in Progress'} minHeight={150} height={150} />
            </Card>
    );
};

export default BuilderStatesManager;

